import React from 'react';
import Styled from './WaterSafe.style';
import Typography from '../Typography';
import { useNavigate } from 'react-router-dom';
interface WaterSafeProps {
  postcode: string;
  slug: string;
  isDesktop: boolean;
  style?: React.CSSProperties;
  plumberVisit: any;
}
const WaterSafe: React.FC<WaterSafeProps> = (props) => {
  const { postcode, isDesktop, plumberVisit, slug } = props;

  const navigate = useNavigate();
  const externalUrl = `https://www.watersafe.org.uk/search/?q=${postcode}&household=true`;

  return (
    <Styled.GWFCard
      style={{
        padding: '24px',
        background: 'rgb(33, 170, 232)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        ...props.style,
      }}
    >
      {plumberVisit ? (
        <div
          style={{
            display: 'flex',
            flexDirection: isDesktop ? 'row' : 'column',
          }}
        >
          <Typography
            size="p"
            text="Your business qualifies for a free leak repair"
            style={{
              color: 'white',
              padding: '0',
              margin: isDesktop ? '0 8px 0 0' : '0 0 8px 0',
              fontSize: isDesktop ? '20px' : '16px',
              fontWeight: 600,
            }}
          />
          <img
            src={`https://cdn.getwaterfit.co.uk/static/files/logos/business/${slug}-color.png`}
            alt={slug}
            style={{
              width: '140px',
            }}
          />
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: isDesktop ? 'row' : 'column',
          }}
        >
          <Typography
            size="p"
            text="Find a local"
            style={{
              color: 'white',
              padding: '0',
              margin: isDesktop ? '0 8px 0 0' : '0 0 8px 0',
              fontSize: isDesktop ? '20px' : '16px',
              fontWeight: 600,
            }}
          />
          <img
            src="https://cdn.getwaterfit.co.uk/static/files/images/watersafe-white.png"
            alt="WaterSafe"
          />
          <Typography
            size="p"
            text="qualified plumber"
            style={{
              color: 'white',
              padding: '0',
              margin: isDesktop ? '0 0 0 8px' : '8px 0 0 0',
              fontSize: isDesktop ? '20px' : '16px',
              fontWeight: 600,
            }}
          />
        </div>
      )}

      {plumberVisit ? (
        <p
          style={{
            background: 'white',
            padding: '8px 16px',
            color: 'black',
            borderRadius: '8px',
            margin: '0',
            fontSize: isDesktop ? '16px' : '12px',
            fontWeight: 600,
            textDecoration: 'none',
          }}
          onClick={() => navigate('/actions')}
        >
          Book now
        </p>
      ) : (
        <a
          href={externalUrl}
          target="_blank"
          style={{
            background: 'white',
            padding: '8px 16px',
            color: 'black',
            borderRadius: '8px',
            margin: '0',
            fontSize: isDesktop ? '16px' : '12px',
            fontWeight: 600,
            textDecoration: 'none',
          }}
          rel="noopener noreferrer"
        >
          Find a plumber
        </a>
      )}
    </Styled.GWFCard>
  );
};
export default WaterSafe;
